<template>
  <div>
    <vs-button
      color="primary"
      type="filled"
      icon-pack="feather"
      icon="icon-filter"
      class="w-full"
      @click="isOpen = true"
    >
      {{ $t('filters') | capitalize }}
    </vs-button>

    <base-modal :isOpen="isOpen" :title="$t('filters') | capitalize"  @close="isOpen = false">

      <!-- Body -->
      <template #body>
        <vs-row class="mb-2">
          <vs-col class="px-2">
            <v-select
              class="w-full"
              label="client_name"
              :placeholder="$t('client')"
              :value="filters.client"
              @input="updateFilter('client', $event)"
              :reduce="(item) => item.client_id"
              :options="clientList"
              clearable
            >
            </v-select>
          </vs-col>
        </vs-row>

      </template>

      <!-- Footer -->
      <template #footer>
        <vs-button color="danger" type="border" @click="isOpen = false">
          {{ $t('cancel') | capitalize }}
        </vs-button>
        <vs-button color="danger" @click="handleSubmit">
          {{ $t('apply') | capitalize }}
        </vs-button>
      </template>
    </base-modal>
  </div>
</template>

<script>
import BaseModal from '@/views/app/components/modals/BaseModal.vue';
import vSelect from 'vue-select'

export default {
  name: 'ExpenseFilter',
  components: { BaseModal, 'v-select': vSelect},
  props: {
    clientList: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Object,
      default: () => ({
        client: null,
        //week: null
      })
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    updateFilter(key, value) {
      this.$emit('update:filters', { ...this.filters, [key]: value })
    },
    handleSubmit() {
      this.$emit('apply-filters', this.filters)
      this.isOpen = false
    }
  }
}
</script>